import Cookies from "universal-cookie";

const cookies = new Cookies();

export function getWinnerPopup() {
  return cookies.get("winner-popup");
}

export function setWinnerPopup(status, timeExpired = 3600) {
  cookies.set("winner-popup", status, {
    path: "/",
    maxAge: timeExpired,
  });
  window.localStorage.setItem("winner-popup", JSON.stringify(status));
}

export function getNotifyChangeBid() {
  return cookies.get("notify-popup");
}

export function setNotifyChangeBid(status, timeExpired = 3600) {
  cookies.set("notify-popup", status, {
    path: "/",
    maxAge: timeExpired,
  });
  window.localStorage.setItem("notify-popup", JSON.stringify(status));
}

export function setEventCookie(key = "isShowPopupEvent", timer = 0) {
  const cookies = new Cookies();
  const oneDay = 24 * 60 * 60 * 1000; // 1 ngày tính bằng mili giây
  const timeActive = timer || oneDay;

  cookies.set(key, true, {
    path: "/",
    expires: new Date(Date.now() + timeActive),
  });
}

export function getCookieShowPopupEvent(key = "isShowPopupEvent") {
  return cookies.get(key);
}

export function isLoggedIn() {
  return cookies.get("isLoggedIn");
}

export function isDetected() {
  return cookies.get("isDetected");
}
export function getShowFreeBidPopup(userId) {
  return cookies.get("show-free-bid-popup-" + userId);
}
export function setShowFreeBidPopup(status, userId) {
  let key = "show-free-bid-popup-" + userId
  let date = new Date();
  let dateFuture = new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate() + 1
  );
  let expires = "; expires=" + dateFuture.toGMTString();
  document.cookie = key + "=" + `${status}` + expires + "; path=/";
}
export function setShowNotification() {
  let date = new Date();
  let datePeru = new Date(date.getTime() - 5 * 3600 * 1000);
  let dateFuture = new Date(
    datePeru.getUTCFullYear(),
    datePeru.getUTCMonth(),
    datePeru.getUTCDate() + 1,
    12,
    0
  );
  let expires = "; expires=" + dateFuture.toGMTString();
  document.cookie = "showedNotification" + "=" + "1" + expires + "; path=/";
}
export function getShowNotification() {
  return cookies.get("showedNotification") || null;
}


export function getItemCookie(name) {
  return cookies.get(name);
}

export function setCookieExpireEndOfDay(name, value = true) {
  const endOfDay = new Date();  
  endOfDay.setHours(23, 59, 59, 999); // set thời gian hết hạn đến cuối ngày hôm nay

  cookies.set(name, value, {
    path: '/',
    expires: endOfDay,
  });
}
export function deleteItemCookie(name) {
  return cookies.remove(name)
}